/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonBase,
  PersonBaseOptional,
  PersonBaseMetaI,
  PersonBaseTrackedI,
} from "./person-base";
import { PersonBaseTracked, PersonBaseMeta } from "./person-base";

/**
 *
 * @export
 * @interface PersonRelationBBase
 */
export interface PersonRelationBBaseOptional {
  /**
   *
   * @type {PersonBase}
   * @memberof PersonRelationBBase
   */
  A?: PersonBaseOptional;
}

export interface PersonRelationBBase extends PersonRelationBBaseOptional {
  /**
   *
   * @type {PersonBase}
   * @memberof PersonRelationBBase
   */
  A: PersonBase;
}

export interface PersonRelationBBaseTrackedI {
  /**
   *
   * @type {PersonBase}
   * @memberof PersonRelationBBase
   */
  A?: PersonBaseTrackedI;
  AIsSet: boolean;
}

transformDatesMap.set(
  "PersonRelationBBase",
  function (model: PersonRelationBBase) {
    const transformDatesA = transformDatesMap.get("PersonBase");
    if (transformDatesA && model.A) {
      transformDatesA(model.A);
    }
  },
);

export type PersonRelationBBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  A: PropertyMeta<PersonBaseMetaI>;
}>;

export var PersonRelationBBaseMeta: PersonRelationBBaseMetaI =
  {} as PersonRelationBBaseMetaI;
PersonRelationBBaseMeta = typeMeta("PersonRelationBBase", {
  A: propertyMeta("A", false, true, false, PersonBaseMeta),
});

const metaI = PersonRelationBBaseMeta;

registerMeta(() => {});

export class PersonRelationBBaseTracked implements PersonRelationBBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  A__I?: PersonBaseTracked = undefined;
  AIsSet: boolean = false;
  set A(v: undefined | PersonBaseTracked) {
    if (v !== undefined) {
      this.A__I = v;
      this.AIsSet = true;
    } else {
      this.A__I = v || undefined;
      this.AIsSet = true;
    }
    this.changeTracker = true;
  }
  get A() {
    return this.A__I;
  }
  constructor(config?: PersonRelationBBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.A?.setIds();
  }
  assignFrom(
    config: PersonRelationBBaseOptional,
    options?: AssignOptions,
  ): PersonRelationBBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.A && this.AApplyFilter(optionsRequired.filter)) {
      this.A = new PersonBaseTracked(config.A, options);
      if (optionsRequired.unassign) this.AIsSet = false;
      else this.AIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonRelationBBaseTrackedI {
    const cloned = {} as PersonRelationBBaseTrackedI;
    if (
      this.AIsSetDeep() &&
      this.AApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.AIsSet = true;
      cloned.A = this.A?.removeUnset(filter);
    } else {
      //cloned.AIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonRelationBBaseTrackedI {
    if (!this.AApplyFilter(filter)) this.AIsSet = false;
    this.A?.unassignAll(filter);

    return this;
  }
  AApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonRelationBBaseMeta.A,
      PersonRelationBBaseMeta,
      this.A,
      this,
    );
  }
  AIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.AIsSet && this.AApplyFilter(filter)) return true;
    return this.A?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.AIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
